import React from "react";
import StyledSpinner from "../../styles/StyledSpinner";

const Spinner = () => (
  <StyledSpinner>
    <svg
      width="200"
      height="150"
      viewBox="0 0 800 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-reactroot=""
    >
      <path
        d="M667.214 299.996C667.214 346.785 655.45 390.834 634.705 429.331C634.63 429.451 634.57 429.586 634.495 429.706C588.335 515.095 497.991 573.11 394.101 573.11C243.273 573.11 120.988 450.84 120.988 299.996C120.988 284.685 122.246 269.673 124.67 255.034C124.76 254.45 124.865 253.851 124.97 253.268C146.029 131.133 248.213 36.7618 374.045 27.6322C380.66 27.1382 387.351 26.8984 394.101 26.8984C476.528 26.8984 550.423 63.4045 600.489 121.134C642.069 169.06 667.214 231.594 667.214 299.996Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.105 11C386.961 11 379.882 11.2537 372.883 11.7764L372.881 11.7765C239.727 21.4373 131.596 121.301 109.311 250.543C106.539 266.619 105.098 283.139 105.098 299.992C105.098 459.614 234.499 589 394.105 589C504.199 589 599.928 527.437 648.712 436.853L649.593 437.327L648.712 436.853C670.664 396.117 683.113 349.506 683.113 299.992C683.113 227.609 656.505 161.436 612.505 110.72L613.221 110.099L612.505 110.72C559.523 49.6293 481.329 11 394.105 11ZM372.735 9.78185C379.785 9.25536 386.914 9 394.105 9C481.933 9 560.67 47.8994 614.016 109.41L613.26 110.065L614.016 109.41C658.319 160.476 685.113 227.11 685.113 299.992C685.113 349.845 672.578 396.781 650.473 437.802C601.354 529.007 504.963 591 394.105 591C233.395 591 103.098 460.719 103.098 299.992C103.098 283.025 104.549 266.391 107.34 250.203L108.324 250.373L107.34 250.203C129.779 120.064 238.656 19.5103 372.735 9.78185Z"
        fill="#B5CDFB"
      ></path>
      <path
        className="fill"
        d="M634.495 429.706C588.335 515.096 497.991 573.111 394.101 573.111C243.273 573.111 120.988 450.841 120.988 299.997C120.988 284.685 122.246 269.673 124.67 255.035C125.434 255.184 126.167 255.394 126.93 255.633C126.93 255.633 188.627 215.565 255.906 274.388C323.185 333.195 308.816 497.569 394.715 468.637C480.614 439.69 496.839 424.647 530.411 426.952C563.968 429.272 594.442 436.217 600.04 417.687C604.8 401.971 627.805 422.746 634.495 429.706Z"
        fill="#000000"
      ></path>
      <path
        className="fill"
        d="M581.966 299.891C602.187 320.651 594.644 355.286 567.627 365.778C554.156 371.002 541.045 375.283 531.93 376.42C504.419 379.863 476.894 390.191 452.826 335.723C428.743 281.272 395.5 324.842 367.99 298.5C340.465 272.171 417.278 219.366 427.77 117.332C438.263 15.2986 394.348 96.692 377.853 94.4015C367.197 92.9201 370.31 54.603 373.857 27.6614C373.962 27.6468 374.052 27.6315 374.157 27.6315C380.637 27.1374 387.358 26.8984 394.108 26.8984C472.763 26.8984 547.451 60.9343 599.089 120.31C581.322 128.767 563.257 134.784 552.57 138.885C526.197 148.989 526.197 207.901 522.919 225.099C521.063 234.828 553.483 270.645 581.966 299.891Z"
        fill="#000000"
      ></path>
      <path
        d="M200.037 92.899C200.281 91.2473 200.448 89.5713 200.448 87.8528C200.448 68.8544 185.047 53.4531 166.049 53.4531H153.278C134.28 53.4531 118.879 68.8544 118.879 87.8528H98.3994C79.4012 87.8528 64 103.254 64 122.252C64 141.251 79.4012 156.652 98.3994 156.652H182.169C201.168 156.652 216.569 141.251 216.569 122.252C216.569 109.807 209.937 98.9383 200.037 92.899Z"
        fill="#B5CDFB"
      ></path>
      <path
        d="M171.135 69.3307C171.821 69.3307 172.377 68.7746 172.377 68.0887C172.377 67.4027 171.821 66.8467 171.135 66.8467C170.449 66.8467 169.893 67.4027 169.893 68.0887C169.893 68.7746 170.449 69.3307 171.135 69.3307Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M181.406 76.4518C182.092 76.4518 182.648 75.8957 182.648 75.2098C182.648 74.5238 182.092 73.9678 181.406 73.9678C180.72 73.9678 180.164 74.5238 180.164 75.2098C180.164 75.8957 180.72 76.4518 181.406 76.4518Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M171.754 80.4644C172.44 80.4644 172.996 79.9084 172.996 79.2225C172.996 78.5365 172.44 77.9805 171.754 77.9805C171.068 77.9805 170.512 78.5365 170.512 79.2225C170.512 79.9084 171.068 80.4644 171.754 80.4644Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M203.762 136.591C204.447 136.591 205.004 136.035 205.004 135.349C205.004 134.663 204.447 134.107 203.762 134.107C203.076 134.107 202.52 134.663 202.52 135.349C202.52 136.035 203.076 136.591 203.762 136.591Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M190.406 114.713C191.092 114.713 191.648 114.157 191.648 113.471C191.648 112.786 191.092 112.229 190.406 112.229C189.72 112.229 189.164 112.786 189.164 113.471C189.164 114.157 189.72 114.713 190.406 114.713Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M183.4 99.9029C184.086 99.9029 184.642 99.3469 184.642 98.6609C184.642 97.975 184.086 97.4189 183.4 97.4189C182.714 97.4189 182.158 97.975 182.158 98.6609C182.158 99.3469 182.714 99.9029 183.4 99.9029Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M190.406 130.329C191.092 130.329 191.648 129.773 191.648 129.087C191.648 128.401 191.092 127.845 190.406 127.845C189.72 127.845 189.164 128.401 189.164 129.087C189.164 129.773 189.72 130.329 190.406 130.329Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M197.098 106.978C198.14 106.978 198.985 106.133 198.985 105.091C198.985 104.049 198.14 103.204 197.098 103.204C196.056 103.204 195.211 104.049 195.211 105.091C195.211 106.133 196.056 106.978 197.098 106.978Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M203.76 121.53C204.802 121.53 205.647 120.685 205.647 119.643C205.647 118.601 204.802 117.756 203.76 117.756C202.718 117.756 201.873 118.601 201.873 119.643C201.873 120.685 202.718 121.53 203.76 121.53Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M177.68 147.939C178.722 147.939 179.567 147.094 179.567 146.052C179.567 145.01 178.722 144.165 177.68 144.165C176.638 144.165 175.793 145.01 175.793 146.052C175.793 147.094 176.638 147.939 177.68 147.939Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M187.276 86.723C188.318 86.723 189.162 85.8782 189.162 84.8361C189.162 83.794 188.318 82.9492 187.276 82.9492C186.233 82.9492 185.389 83.794 185.389 84.8361C185.389 85.8782 186.233 86.723 187.276 86.723Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M194.326 146.056C195.368 146.056 196.213 145.211 196.213 144.169C196.213 143.127 195.368 142.282 194.326 142.282C193.284 142.282 192.439 143.127 192.439 144.169C192.439 145.211 193.284 146.056 194.326 146.056Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M703.625 376.271H626.957C609.57 376.271 595.475 362.176 595.475 344.788V344.788C595.475 327.401 609.57 313.306 626.957 313.306H703.625C721.012 313.306 735.107 327.401 735.107 344.788V344.788C735.107 362.176 721.012 376.271 703.625 376.271Z"
        fill="#B5CDFB"
      ></path>
      <path
        d="M677.02 344.788H665.332C647.945 344.788 633.85 330.692 633.85 313.305V313.305C633.85 295.918 647.945 281.822 665.332 281.822H677.02C694.408 281.822 708.503 295.918 708.503 313.305V313.305C708.503 330.692 694.408 344.788 677.02 344.788Z"
        fill="#B5CDFB"
      ></path>
      <path
        d="M682.765 292.521C683.451 292.521 684.007 291.965 684.007 291.279C684.007 290.593 683.451 290.037 682.765 290.037C682.079 290.037 681.523 290.593 681.523 291.279C681.523 291.965 682.079 292.521 682.765 292.521Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M693.037 299.632C693.723 299.632 694.279 299.076 694.279 298.39C694.279 297.704 693.723 297.148 693.037 297.148C692.351 297.148 691.795 297.704 691.795 298.39C691.795 299.076 692.351 299.632 693.037 299.632Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M683.385 303.645C684.07 303.645 684.627 303.089 684.627 302.403C684.627 301.717 684.07 301.161 683.385 301.161C682.699 301.161 682.143 301.717 682.143 302.403C682.143 303.089 682.699 303.645 683.385 303.645Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M724.99 359.778C725.676 359.778 726.232 359.222 726.232 358.536C726.232 357.85 725.676 357.294 724.99 357.294C724.304 357.294 723.748 357.85 723.748 358.536C723.748 359.222 724.304 359.778 724.99 359.778Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M711.631 337.899C712.317 337.899 712.873 337.343 712.873 336.657C712.873 335.971 712.317 335.415 711.631 335.415C710.945 335.415 710.389 335.971 710.389 336.657C710.389 337.343 710.945 337.899 711.631 337.899Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M704.625 323.095C705.311 323.095 705.867 322.539 705.867 321.853C705.867 321.167 705.311 320.611 704.625 320.611C703.939 320.611 703.383 321.167 703.383 321.853C703.383 322.539 703.939 323.095 704.625 323.095Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M711.631 353.523C712.317 353.523 712.873 352.967 712.873 352.281C712.873 351.595 712.317 351.039 711.631 351.039C710.945 351.039 710.389 351.595 710.389 352.281C710.389 352.967 710.945 353.523 711.631 353.523Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M718.324 330.158C719.366 330.158 720.211 329.314 720.211 328.272C720.211 327.23 719.366 326.385 718.324 326.385C717.282 326.385 716.438 327.23 716.438 328.272C716.438 329.314 717.282 330.158 718.324 330.158Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M724.988 344.71C726.031 344.71 726.875 343.865 726.875 342.823C726.875 341.781 726.031 340.937 724.988 340.937C723.946 340.937 723.102 341.781 723.102 342.823C723.102 343.865 723.946 344.71 724.988 344.71Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M698.906 371.118C699.949 371.118 700.793 370.274 700.793 369.232C700.793 368.19 699.949 367.345 698.906 367.345C697.864 367.345 697.02 368.19 697.02 369.232C697.02 370.274 697.864 371.118 698.906 371.118Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M698.906 309.91C699.949 309.91 700.793 309.066 700.793 308.024C700.793 306.981 699.949 306.137 698.906 306.137C697.864 306.137 697.02 306.981 697.02 308.024C697.02 309.066 697.864 309.91 698.906 309.91Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
      <path
        d="M715.553 369.237C716.595 369.237 717.44 368.392 717.44 367.35C717.44 366.308 716.595 365.463 715.553 365.463C714.511 365.463 713.666 366.308 713.666 367.35C713.666 368.392 714.511 369.237 715.553 369.237Z"
        fill="none"
        stroke="#221b38"
        strokeWidth="1"
      ></path>
    </svg>
    <span>Loading...</span>
  </StyledSpinner>
);
export default Spinner;
